import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Globally-shared header selection (ids), so every tab/component can read the
 * currently-selected district / block / school / academic year without prop
 * drilling. Names drive the drill-down UI; these ids drive the API calls.
 */
export interface SelectionState {
  districtId: number | null;
  blockId: number | null;
  schoolId: number | null;
  acdYr: number | null;
}

const initialState: SelectionState = {
  districtId: null,
  blockId: null,
  schoolId: null,
  acdYr: null,
};

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    setSelection(state, action: PayloadAction<Partial<SelectionState>>) {
      return { ...state, ...action.payload };
    },
    clearSelection() {
      return initialState;
    },
  },
});

export const { setSelection, clearSelection } = selectionSlice.actions;
export default selectionSlice.reducer;
